import React, { type ReactElement } from 'react';

import ClusterOffering from './Offering';
import ClusterSection from './Section';
import { OFFERINGS, OFFERING_HEADLINE } from './constants';

const ClusterOfferings = (): ReactElement => (
  <ClusterSection
    className="mt-48 border-0 border-b border-solid border-pro-gold px-16 pb-48 sm:px-0 sm:pb-64"
    headline={OFFERING_HEADLINE}
  >
    <div className="mt-32 flex flex-col gap-y-48 sm:flex-row sm:justify-center sm:gap-64 md:gap-48 lg:justify-start lg:gap-112">
      {OFFERINGS.map((offering) => (
        <ClusterOffering
          key={offering.link}
          buttonText={offering.buttonText}
          description={offering.description}
          headline={offering.headline}
          link={offering.link}
        />
      ))}
    </div>
  </ClusterSection>
);

export default ClusterOfferings;
